export enum SocialNetworksEnum {
  'facebook' = 'facebook',
  'google' = 'google',
  'instagram' = 'instagram',
  'linkedin' = 'linkedin',
  'pinterest' = 'pinterest',
  'twitter' = 'twitter',
  'bitly' = 'bitly',
  'tiktok' = 'tiktok',
  'youtube' = 'youtube',
  'threads' = 'threads',
  'universal' = 'universal'
}
